// extracted by mini-css-extract-plugin
export default {"TermsPage":"TermsPage_TermsPage__xoiXP","PanelSection":"TermsPage_PanelSection__M-vKP"};